export default {
  live: process.env.VUE_APP_LIVE,
  www: process.env.VUE_APP_WEB,
  user: process.env.VUE_APP_USER_DOMAIN,
  doc: process.env.VUE_APP_DOC_DOMAIN,
  med: process.env.VUE_APP_MED_DOMAIN,
  web: process.env.VUE_APP_WEB_DOMAIN
};